import React, { useState, useEffect } from "react";
import NuovaOrchestra from "../imgs/Nuova orchestra.png";
import colorimusica from "../imgs/i colori della musica.jpg";
import { FaUsers, FaBullseye, FaLightbulb, FaMusic } from "react-icons/fa";
import { GiNewspaper } from "react-icons/gi";
import { useForm, ValidationError } from "@formspree/react";

import concerto22novembre from "../imgs/Concerto22Novembre2025.jpg";
import Uttaro1 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-1.jpg";
import Uttaro2 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-2.jpg";
import Uttaro3 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-3.jpg";
import Uttaro5 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-5.jpg";
import Uttaro6 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-6.jpg";
import Uttaro8 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-8.jpg";
import Uttaro9 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-9.jpg";
import Uttaro10 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-10.jpg";
import Uttaro11 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-11.jpg";
import Uttaro12 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-12.jpg";
import Uttaro13 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-13.jpg";
import Uttaro14 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-14.jpg";
import Uttaro15 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-15.jpg";
import Uttaro17 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-17.jpg";
import Uttaro18 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-18.jpg";
import Uttaro19 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-19.jpg";
import Uttaro20 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-20.jpg";
import Uttaro21 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-21.jpg";
import Uttaro22 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-22.jpg";
import Uttaro23 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-23.jpg";
import Uttaro25 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-25.jpg";
import Uttaro26 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-26.jpg";
import Uttaro27 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-27.jpg";
import Uttaro28 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-28.jpg";
import locNatale from "../imgs/Locandina natale 2.jpg";
import loc03012026 from "../imgs/Locandina03012026.jpeg";

const Home = () => {
  const images = [
    Uttaro1,
    Uttaro2,
    Uttaro3,
    // Uttaro4,
    Uttaro5,
    Uttaro6,
    Uttaro8,
    Uttaro9,
    Uttaro10,
    Uttaro11,
    Uttaro12,
    Uttaro13,
    Uttaro14,
    Uttaro15,
    Uttaro17,
    Uttaro18,
    Uttaro19,
    Uttaro20,
    Uttaro21,
    Uttaro22,
    Uttaro23,
    // Uttaro24,
    Uttaro25,
    Uttaro26,
    Uttaro27,
    Uttaro28,
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [fullScreenImage, setFullScreenImage] = useState(null);

  const [state, handleSubmit] = useForm("xpwkaddj");

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setIsAnimating(true);
  //     setTimeout(() => {
  //       setCurrentIndex((prev) => (prev + 1) % images.length);
  //       setIsAnimating(false);
  //     }, 800);
  //   }, 4000);
  //   return () => clearInterval(interval);
  // }, [images.length]);

  useEffect(() => {
    let timeoutId;

    const intervalId = setInterval(() => {
      setIsAnimating(true);
      timeoutId = setTimeout(() => {
        if (images.length > 0) {
          setCurrentIndex((prev) => (prev + 1) % images.length);
        }
        setIsAnimating(false);
      }, 800);
    }, 4000);

    return () => {
      clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [images.length]);

  const handleImageClick = (img) => setFullScreenImage(img);
  const closeImage = () => setFullScreenImage(null);

  return (
    <div className="flex flex-col items-center bg-gradient-to-r from-white to-amber-50 min-h-screen text-gray-800 overflow-hidden">
      {/* Titolo */}
      <h1 className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        NEWS
      </h1>
      <GiNewspaper className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />
      {/* Carosello */}
      <div className="relative w-11/12 md:w-3/4 lg:w-2/3 h-80 md:h-[28rem] rounded-2xl overflow-hidden shadow-lg mt-5 mb-10 bg-white">
        <img
          src={images[currentIndex]}
          alt="Galleria Milarte"
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
            isAnimating ? "opacity-0" : "opacity-100"
          }`}
          onClick={() => handleImageClick(images[currentIndex])}
        />
        <img
          src={NuovaOrchestra}
          alt="Logo Nuova Orchestra"
          className="absolute top-4 left-4 w-28 md:w-40 opacity-90 drop-shadow-lg"
        />
      </div>

      {/* Citazione */}
      <div className="bg-white/60 backdrop-blur-md rounded-2xl shadow-md p-8 w-11/12 md:w-3/4 lg:w-2/3 text-center transition-all hover:shadow-xl">
        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
          NUOVA MILANO
        </h2>
        <p className="text-gray-700 italic leading-relaxed">
          “Una scatola sono di cerini, i musicisti mentre stanno insieme, pronti
          a incendiarsi per spiccare il volo. Saranno un palloncino della fiera
          come quelli sfuggiti dalle mani che sembrano uno stormo cittadino o un
          labirinto in note musicali che anche a una carriola dà le ali.”
        </p>
        <p className="mt-4 text-sm md:text-base font-semibold text-gray-700">
          Guido Oldani – Ideatore del Realismo Terminale (inedito)
        </p>
      </div>

      {/* Locandina */}
      <div className="md:w-1/4 xs:w-2/4 mt-10 mb-12 transform hover:scale-[1.03] transition-transform duration-500 cursor-pointer">
        <img
          src={loc03012026}
          alt="Locandina Concerto"
          className="w-full rounded-2xl shadow-lg"
          onClick={() => handleImageClick(loc03012026)}
        />
      </div>

      {/* Testo descrittivo */}
      <div className="w-11/12 md:w-3/4 lg:w-2/3 mb-16 text-center space-y-10">
        <p className="text-lg leading-relaxed">
          <FaUsers className="inline text-red-600 text-2xl mr-2" />
          MilArte è un'Associazione di Promozione Sociale dedicata alla musica,
          fondata nel 2023 con l'obiettivo di diffondere la passione musicale e
          creare un impatto positivo nella comunità. La visione di{" "}
          <a
            href="https://www.giuseppedinardo.it/"
            className="text-red-600 font-semibold hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Giuseppe Dinardo
          </a>{" "}
          ha guidato la nascita dell’associazione, consolidando la sua presenza
          nel panorama musicale milanese.
        </p>

        <p className="text-lg leading-relaxed">
          <FaBullseye className="inline text-amber-600 text-2xl mr-2" />
          Gli obiettivi principali includono la proposta di concerti, eventi e
          iniziative culturali per rendere la musica accessibile e viva. MilArte
          lavora per creare esperienze musicali che arricchiscano la vita di chi
          ascolta e di chi suona.
        </p>

        <p className="text-lg leading-relaxed">
          <FaLightbulb className="inline text-yellow-500 text-2xl mr-2" />
          In programma anche visite e concerti nelle scuole per condividere la
          magia della musica fatta con mani umane e nutrire interiormente i
          giovani ascoltatori.
        </p>
      </div>

      {/* Modal fullscreen */}
      {fullScreenImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={closeImage}
        >
          <img
            src={fullScreenImage}
            alt="Full screen"
            className="max-w-[90vw] max-h-[90vh] rounded-2xl shadow-2xl"
          />
        </div>
      )}

      {/* --- SEZIONE NEWSLETTER --- */}
      <div className="w-full flex flex-col items-center text-center mb-10 z-10 px-11">
        <h2 className="text-2xl font-bold text-red-600 mb-3">
          Iscriviti alla Newsletter
        </h2>

        <p className="text-gray-700 max-w-xl mb-4">
          Rimani aggiornato su corsi, eventi e iniziative. <br />
          <span className="text-red-600 font-semibold">
            Iscrivendoti oggi riceverai anche un piccolo gadget omaggio!
          </span>
        </p>

        {state.succeeded ? (
          <p className="text-green-600 text-lg font-semibold">
            ✅ Grazie per aver inviato la tua iscrizione! Ti contatteremo
            presto.
            <br />
            🎁 E non dimenticare: un gadget omaggio ti aspetta!
          </p>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full max-w-4xl text-left"
          >
            <input type="hidden" name="_subject" value="Milarte Newsletter" />

            <div className="flex flex-col sm:col-span-2">
              <label
                htmlFor="Email"
                className="text-sm font-medium text-gray-700"
              >
                Email
              </label>
              <input
                id="Email"
                name="Email"
                type="Email"
                required
                placeholder="Inserisci la tua email"
                className="mt-1 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
              />
            </div>

            {/* --- BOTTONE --- */}
            <div className="col-span-full flex justify-center mt-4">
              <button
                type="submit"
                disabled={state.submitting}
                className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition disabled:opacity-50 font-semibold"
              >
                Invia Iscrizione
              </button>
            </div>
          </form>
        )}
      </div>
      {/* --- FINE SEZIONE NEWSLETTER --- */}
    </div>
  );
};

export default Home;
